import React from "react";

const FoodKindredProductsIcon = ({
  color = "#5D5D5D",
  width = "21",
  height = "25",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 25"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25391 1H15.7134V5.18381H5.25391V1Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M3.16276 9.88216C4.37847 9.88216 4.37847 8.84169 5.60514 8.84169C6.8318 8.84169 6.82085 9.88216 8.04752 9.88216C9.27419 9.88216 9.26323 8.84169 10.4899 8.84169C11.7166 8.84169 11.7056 9.88216 12.9213 9.88216C14.137 9.88216 14.148 8.84169 15.3637 8.84169C16.5794 8.84169 16.5794 9.88216 17.7951 9.88216L18.8904 9.3674L15.7032 5.18359H5.25466L2.11133 9.3674L3.16276 9.88216Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.7964 9.36719V20.8672C17.7964 21.6979 17.4664 22.4947 16.879 23.0821C16.2916 23.6696 15.4948 23.9996 14.6641 23.9996H6.29644C5.46568 23.9996 4.66895 23.6696 4.08152 23.0821C3.49408 22.4947 3.16406 21.6979 3.16406 20.8672V9.36719"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.43956 14.5928H11.5315C11.5315 14.5928 13.6234 14.5928 13.6234 16.6847C13.6234 18.7766 13.6234 18.7766 11.5315 18.7766H9.43956C9.43956 18.7766 7.34766 18.7766 7.34766 16.6847C7.34766 14.5928 7.34766 14.5928 9.43956 14.5928Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default FoodKindredProductsIcon;
